// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React, { useState, useCallback } from "react";
import { Link } from "react-router";
import { ENV } from "../../../ENV";

import { Button } from "../../../../web-utils/src/UI/Component/React/V1/Button/Button";

import MosysLogo from "../../../../web-utils/shared/img/MoSysLogo.svg";

import { NavigationList } from "./NavigationList/NavigationList";

import styles from "./Navigation.module.css";

export const Navigation = ({ navigation }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileOpen((prev) => !prev);
  }, []);

  return (
    <nav className={styles.nav}>
      <Link to="/" className={styles.navbar_brand}>
        <MosysLogo />
      </Link>
      {ENV.USE_LOCAL_ACCOUNTS ? null : (
        <Link to="/" className={styles.navbar_brand}>
          <img src="/logo.png" alt="External Logo" />
        </Link>
      )}
      <div className={`${!navigation && styles.subnav}`}>
        {navigation && (
          <>
            <div className={styles.toggler}>
              <Button
                onClick={toggleMobileMenu}
                color="light"
                iconType="menu"
              />
            </div>
            <div
              className={`${styles.navbar} ${isMobileOpen ? styles.show : ""}`}
            >
              <div className={styles.toggler}>
                <Button
                  onClick={toggleMobileMenu}
                  color="light"
                  iconType={isMobileOpen && "close"}
                />
              </div>
              <NavigationList isLocalUser={ENV.USE_LOCAL_ACCOUNTS} />
            </div>
          </>
        )}
      </div>
    </nav>
  );
};
